export default function PHP_array_product() {
  return (
    <div>
      <h1>PHP_array_product</h1>
    </div>
  );
}
